import { createAction } from 'redux-actions';

export const DELETE_FOLDER = 'DELETE_FOLDER';

export default createAction(DELETE_FOLDER);
